import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import dataReducer from "./modules/reducers";
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

const persistConfig = {
  key: 'root',
  storage,
}
const persistedReducer = persistReducer(persistConfig, dataReducer)


const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware))

let store = createStore(persistedReducer, composedEnhancer)
let persistor = persistStore(store)

export { store, persistor };
